module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/2/5-bb98503c500c358a7eea2dc19efc5373.jpg";